<!-- HeaderComponent.vue -->
<template>
  <header>
    <div v-if="isFleet"></div>
    <div v-else class="logo">
        <!-- <img src="..\..\..\..\public\logo.png" /> -->
        <img :src="require('@/assets/logo.png')" />
        <span class="pobocka">Pobočka&nbsp;{{ servisName }}</span>
    </div>
    <ul v-if="!isFleet">
        <li><a href="#" @click="goToMain">Hlavní přehled</a></li>
        <!-- <li><a href="#" @click="goToArchived">Archivované zakázky</a></li> -->
        <!-- <li><a href="#" @click="goToDeleted">Smazané zakázky</a></li> -->
        <li><a href="#" @click="goToHelp">Návod</a></li>
        <li><a href="#" @click="goToPasswordChange">Změna hesla</a></li>
        <li><a href="#" @click="goToLogin">Odhlásit</a></li>
    </ul>
  </header>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  name: 'HeaderComponent',
  setup() {
    const store = useStore()
    const router = useRouter()

    // Computed properties - convert from computed object
    const servisName = computed(() => store.state.auth?.selectedServis?.servis_name)
    const isFleet = computed(() => store.state.auth?.user?.roles?.includes('FLEET'))

    // Methods - convert to regular functions
    const goToMain = () => router.push({name: 'dashboardMain'})
    const goToArchived = () => router.push({name: 'dashboardArchived'})
    const goToDeleted = () => router.push({name: 'dashboardDeleted'})
    const goToHelp = () => router.push({name: 'dashboardHelp'})
    const goToLogin = () => router.push({name: 'loginCompany'})
    const goToPasswordChange = () => router.push({name: 'passwordChange'})

    return {
      servisName,
      isFleet,
      goToMain,
      goToArchived,
      goToDeleted,
      goToHelp,
      goToLogin,
      goToPasswordChange
    }
  }
}
</script>

<style scoped>

header {
  display: flex;
  padding: 0px 15px;
  justify-content: space-between;
  align-items: center;
}
.logo{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}
.logo img { width: 40px; }

.pobocka {
    margin-left: 35px;
    font-size: 14px;
    font-weight: bold;
}

ul {
    display: flex;
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
li {
    display: flex;
    align-items: center;
    padding: 10px 20px;
    transition: 0.3s;
}
li a {
    display: block;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-decoration: none;
}
li:hover {
      background-color: #333;
}

</style>